import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const headerStyle = css`
  padding: ${theme.spacing(2)};
  gap: ${theme.spacing(1)};
  display: flex;
  align-items: center;
  border-top: 1px solid ${theme.colors.neutral10};
  border-bottom: 1px solid ${theme.colors.neutral10};
`;

export const actionBarStyle = css`
  display: flex;
  gap: ${theme.spacing(1)};
  justify-content: flex-end;
  align-items: center;
  padding: ${theme.spacing(1, 2)};
`;

export const inputContainerStyle = css`
  .create-task-title {
    box-shadow: none !important;
  }

  .create-task-description {
    box-shadow: none !important;
  }
`;

export const bottomBorder = css`
  border-bottom: 1px solid ${theme.colors.neutral10};
  margin-bottom: ${theme.spacing(2)};
`;

export const textFieldStyle = css`
  border: none;
  padding: 0;
  font-weight: ${theme.font.weight.bold};
`;

export const textareaFieldStyle = css`
  border: none;
  padding: 0;
`;

export const formStyle = css`
  padding: ${theme.spacing(2, 1, 2, 3)};
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;
